var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Filter_1;
import React, { Component } from 'react';
import { Density, LocalizedTheme, Placement } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { EditorContext } from '@philips-internal/oswald-ui-core/lib/component/context/index.js';
import { arrayOf, bool, element, eventListener, expression, extendComponent, object, oneOf, oneOfType, string, tuple } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { AbortableClearEvent, AbortableSubmitEvent, ClearEvent, SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { createAbort, enumValues, isDefined, isEmptyArrayOrObject, isEmptyObject, isEqualShallow, isFunction, isObject, isUndefined, noop } from '@philips-internal/oswald-ui-utils';
import { ActionStyle } from '../action/action-constants.js';
import { HeadingContext } from '../heading/components/heading-context/heading-context.js';
import { TokenList } from '../token-list/token-list.js';
import { FilterAPI } from './filter-api.js';
import { FILTER_ACTION_ID } from './filter-constants.js';
import { FilterForm } from './filter-form/filter-form.js';
import { FilterModal } from './filter-modal/filter-modal.js';
import './filter.css';
let Filter = Filter_1 = class Filter extends Component {
    constructor() {
        super(...arguments);
        this.removeDynamicContent = noop;
        this.removeHeadingActions = noop;
        this.popClassName = noop;
        this.state = {
            open: this.props.initialOpen,
            prettyRecord: {},
            record: {},
        };
        this.submitRecord = () => {
            const { onBeforeSubmit, onSubmit } = this.props;
            const abort = createAbort();
            const record = this.getNormalizedRecord();
            if (isFunction(onBeforeSubmit)) {
                onBeforeSubmit(new AbortableSubmitEvent({ abort, record }));
            }
            void abort.promise.then(aborted => {
                if (aborted)
                    return;
                if (isFunction(onSubmit)) {
                    onSubmit(new SubmitEvent({ record }));
                }
                this.setState({ open: false });
            });
        };
        this.onCancel = () => {
            const { onBeforeCancel, onCancel } = this.props;
            const abort = createAbort();
            if (isFunction(onBeforeCancel)) {
                onBeforeCancel(new AbortableSubmitEvent({ abort, record: this.state.record }));
            }
            void abort.promise.then(aborted => {
                if (aborted)
                    return;
                if (isFunction(onCancel)) {
                    onCancel(new SubmitEvent({
                        record: this.state.record,
                    }));
                }
                this.setState({ open: false });
            });
        };
        this.onClear = () => {
            const { onBeforeClear, onClear } = this.props;
            const abort = createAbort();
            if (isFunction(onBeforeClear)) {
                onBeforeClear(new AbortableClearEvent({ abort }));
            }
            void abort.promise.then(aborted => {
                if (aborted)
                    return;
                if (isFunction(onClear)) {
                    onClear(new ClearEvent({}));
                }
            });
        };
        this.onApply = (event) => {
            const { prettyRecord: statePrettyRecord, record: stateRecord } = this.state;
            const { prettyRecord, record } = event;
            if (isEqualShallow(record, stateRecord)) {
                return this.submitRecord();
            }
            const fullPrettyRecord = { ...statePrettyRecord, ...prettyRecord };
            const newPrettyValue = Object.keys(record)
                .filter(key => key in fullPrettyRecord)
                .reduce((accumulator, key) => ({ ...accumulator, [key]: fullPrettyRecord[key] }), {});
            this.setState({ prettyRecord: newPrettyValue, record }, this.submitRecord);
        };
        this.openModal = () => {
            this.setState({ open: true });
        };
        this.clearItem = (key) => {
            const { prettyRecord = {}, record } = this.state;
            const newRecord = { ...record };
            const newPrettyRecord = { ...prettyRecord };
            delete newRecord[key];
            delete newPrettyRecord[key];
            this.setState({ prettyRecord: newPrettyRecord, record: newRecord }, this.submitRecord);
        };
    }
    componentDidMount() {
        this.updateRecordFromDataAndSubmit();
        this.removeHeadingActions = this.addActionsToHeading();
        if (this.context) {
            this.popClassName = this.context.pushCustomClassName('c-filter__contextual-bar');
        }
    }
    addActionsToHeading() {
        if (!this.context) {
            return noop;
        }
        return this.context.addOrUpdateAction({
            enabled: true,
            icon: '/static/assets/components/DLS_Filter.svg',
            iconPlacement: Placement.LEFT,
            id: FILTER_ACTION_ID,
            inlineOnMobile: true,
            onClick: this.openModal,
            style: ActionStyle.INLINE_IMAGE,
        });
    }
    componentDidUpdate(prevProps, prevState) {
        const { data = {} } = this.props;
        const { open, prettyRecord, record } = this.state;
        const emptyPrevDataAndRecord = isEmptyObject(prevProps.data) && isEmptyObject(prevState.record);
        const hasDataAndRecord = !isEmptyObject(data) && !isEmptyObject(record);
        const dataAndRecordAreDifferent = !isEqualShallow(record, data);
        if (emptyPrevDataAndRecord && hasDataAndRecord && dataAndRecordAreDifferent) {
            return this.addTokensToContextualBar(record, this.prettifyRecord(record));
        }
        if (!isEqualShallow(data, prevProps.data)) {
            return this.updateRecordFromDataAndSubmit();
        }
        if (!open && !isEqualShallow(prettyRecord, prevState.prettyRecord)) {
            return this.addTokensToContextualBar(record, prettyRecord);
        }
        if (!open && !isEqualShallow(record, prevState.record)) {
            return this.addTokensToContextualBar(record, this.prettifyRecord(record));
        }
        if (!open && open != prevState.open) {
            this.addTokensToContextualBar(record, this.prettifyRecord(record));
        }
    }
    componentWillUnmount() {
        this.popClassName();
        this.removeHeadingActions();
        this.removeDynamicContent();
    }
    prettifyRecord(record) {
        const { children } = this.props;
        if (!record) {
            return;
        }
        const entries = Object.entries(record).map(([key, value]) => {
            const field = children?.find(child => child.props.entry === key);
            const defaultPrettyValue = [[key], String(value)];
            if (!field) {
                return defaultPrettyValue;
            }
            const { formatPrettyValue } = field.type;
            if (!formatPrettyValue) {
                return defaultPrettyValue;
            }
            const { children: fieldChildren, label } = field.props;
            return [key, formatPrettyValue({ children: fieldChildren, label, value })];
        });
        return Object.fromEntries(entries);
    }
    isValidValue(value) {
        const validObject = isObject(value) && !isEmptyObject(value);
        const validOther = isDefined(value) && !isObject(value) && value !== null && value !== '';
        return validObject || validOther;
    }
    isValidValueForTokenCreation(recordValue, prettyRecordValue) {
        if (Array.isArray(recordValue) || isObject(recordValue)) {
            return !isEmptyArrayOrObject(recordValue);
        }
        return this.isValidValue(recordValue) && this.isValidValue(prettyRecordValue);
    }
    filterPrettyRecordEntries(record, prettyRecord) {
        return Object.entries(prettyRecord)
            .filter(([key, value]) => this.isValidValueForTokenCreation(record[key], value));
    }
    addTokensToContextualBar(record = {}, prettyRecord) {
        if (isFunction(this.removeDynamicContent)) {
            this.removeDynamicContent();
        }
        if (!prettyRecord || Object.keys(prettyRecord).length <= 0 || !this.context) {
            return;
        }
        const { children } = this.props;
        const tokens = this.filterPrettyRecordEntries(record, prettyRecord).map(([key, value]) => {
            const field = children?.find(child => child.props.entry === key);
            const isRequired = field?.props.validators?.some(validator => validator.name === 'required');
            return {
                dismissible: !isRequired,
                filterKey: key,
                value,
            };
        });
        const tokenList = React.createElement(TokenList, { className: "c-filter__token-list", data: tokens, onDismiss: (event) => event.value && this.clearItem(String(event.value['filterKey'])) });
        this.removeDynamicContent = this.context.addOrUpdateDynamicContent({
            element: tokenList,
            id: 'filter-tokens',
        });
    }
    updateRecordFromDataAndSubmit() {
        const { data, initialOpen } = this.props;
        this.setState(({ record }) => {
            const mergedRecord = { ...record, ...data };
            const prettyRecord = this.prettifyRecord(mergedRecord);
            return { prettyRecord, record: mergedRecord };
        }, () => {
            const { prettyRecord, record } = this.state;
            this.addTokensToContextualBar(record, prettyRecord);
            if (initialOpen) {
                return;
            }
            this.submitRecord();
        });
    }
    getNormalizedRecord() {
        const { recordMapper = Filter_1.defaultProps.recordMapper } = this.props;
        const { record } = this.state;
        const mapEntryValue = (entry) => {
            const [key, value] = entry;
            if (!(key in recordMapper) || isUndefined(value) || value === null) {
                return entry;
            }
            const mappedKey = recordMapper[key];
            const get = (obj, keyField) => {
                return keyField in obj ? obj[keyField] : obj.value || obj.key;
            };
            if (isObject(value) && mappedKey in value) {
                return [key, get(value, mappedKey)];
            }
            else if (Array.isArray(value)) {
                const mappedValue = value.filter((item) => mappedKey in item).map(item => get(item, mappedKey));
                return [key, mappedValue];
            }
            return entry;
        };
        const normalizedRecord = Object.entries(record)
            .filter(([, value]) => this.isValidValue(value))
            .map(mapEntryValue)
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        return normalizedRecord;
    }
    renderForm() {
        const { children, density, id, uuid } = this.props;
        const { record } = this.state;
        return (React.createElement(FilterForm, { density: density, id: id, onApply: this.onApply, onClear: this.onClear, record: record, uuid: uuid }, children));
    }
    renderModal() {
        const { modalProps = Filter_1.defaultProps.modalProps, theme, title = Filter_1.defaultProps.title, } = this.props;
        const { open } = this.state;
        if (!open) {
            return null;
        }
        return (React.createElement(FilterModal, { modalProps: modalProps, onClose: this.onCancel, theme: theme, title: title }, this.renderForm()));
    }
    render() {
        return (React.createElement(EditorContext.Consumer, null, editorContext => editorContext?.isDesigning() ? this.renderForm() : this.renderModal()));
    }
};
Filter.contextType = HeadingContext;
Filter.propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    data: object.notEnumerable(),
    density: oneOf(Object.values(Density)),
    id: string.unique().maxLength(40),
    initialOpen: bool,
    modalProps: extendComponent('Modal', [
        'closeByDocument',
        'closeByEscape',
    ], [
        'children',
        'className',
        'closeable',
        'container',
        'contextData',
        'dialogDescription',
        'dockButtons',
        'focusOnOpen',
        'fragment',
        'hideHeaderOnMobile',
        'noPadding',
        'onBeforeClose',
        'onCancel',
        'onClose',
        'onSubmit',
        'theme',
        'title',
        'type',
        'uuid',
    ]),
    onBeforeCancel: eventListener,
    onBeforeClear: eventListener,
    onBeforeSubmit: eventListener,
    onCancel: eventListener,
    onClear: eventListener,
    onSubmit: eventListener,
    recordMapper: tuple([
        string.placeholder('field entry'),
        string.placeholder('value key'),
    ]),
    theme: oneOf(enumValues(LocalizedTheme)),
    title: expression,
    uuid: string,
};
Filter.defaultProps = {
    data: {},
    density: Density.REGULAR,
    modalProps: {
        closeByDocument: true,
        closeByEscape: true,
    },
    recordMapper: {},
    theme: LocalizedTheme.DEFAULT,
    title: 'tws.filter.filter',
};
Filter = Filter_1 = __decorate([
    AwesomeComponent({ api: FilterAPI, type: ComponentType.FORM })
], Filter);
export { Filter, };
//# sourceMappingURL=filter.js.map